import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'


import * as TransaccionCrud from 'services/transaccion.service'

import * as Modals from './modals'

const tableHeaderRows = [
  {
    label: 'CODIGO',
    width: 100,
    filter: {
      type: 'text',
      name: 'cod'
    }
  },
  { label: 'DESCRIPCION' },
  { label: '', width: 60 }
]

const ListaTransaccionesPage = () => {
  const __zariContext = React.useContext(ZariContext)
  const tablaRef = React.useRef(null)
  const editarData = React.useRef(null)
  const editarDataCuentas12 = React.useRef(null)

  const [mostrarEditarTransaccionModal, setMostrarEditarTransaccionModal] = React.useState(false)
  const [mostrarNuevoTransaccionModal, setMostrarNuevoTransaccionModal] = React.useState(false)
  const [mostrarEditarCuentas12Modal, setMostrarEditarCuentas12Modal] = React.useState(false)

  const handleEditarClick = React.useCallback(
    async ({ _id }) => {
      await TransaccionCrud.getTransaccion(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
          setMostrarEditarTransaccionModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const handleEditarCuentas12Click = React.useCallback(
    async ({ _id }) => {
      await TransaccionCrud.getTransaccion(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))

      await TransaccionCrud.getTransaccionCuentas12(_id)
        .then(({ data }) => {
          editarDataCuentas12.current = data
          setMostrarEditarCuentas12Modal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={row._id}>
        <Table.Cell>{row.codigo || '--'}</Table.Cell>
        <Table.Cell>{row.descripcion || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => handleEditarClick({ _id: row._id })}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='editar-cuentas12' handleClose={handleClose} onClick={e => handleEditarCuentas12Click({ _id: row._id })}>
                Editar Cuentas 12
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [handleEditarClick, handleEditarCuentas12Click]
  )

  const clickNuevo = React.useCallback(() => {
    setMostrarNuevoTransaccionModal(true)
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Transacciones'
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
        />
        <Portlet.Body>
          <Table.ServerSide
            useNest={true}
            useFilters={true}
            ref={tablaRef}
            url='/transacciones'
            headRows={tableHeaderRows}
            rowTemplate={rowTemplate}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarEditarTransaccionModal && (
        <Modals.EditarModal
          modalData={editarData.current}
          handleClose={e => setMostrarEditarTransaccionModal(false)}
          show={mostrarEditarTransaccionModal}
          reloadTable={tablaRef.current.reload}
        />
      )}
      {mostrarNuevoTransaccionModal && (
        <Modals.NuevoModal
          handleClose={e => setMostrarNuevoTransaccionModal(false)}
          show={mostrarNuevoTransaccionModal}
          reloadTable={tablaRef.current.reload}
        />
      )}
      {mostrarEditarCuentas12Modal && (
        <Modals.EditarCuentas12Modal
          modalData={editarDataCuentas12.current}
          idTransaccion={editarData.current._id}
          handleClose={e => setMostrarEditarCuentas12Modal(false)}
          show={mostrarEditarCuentas12Modal}
          reloadTable={tablaRef.current.reload}
        />
      )}
    </>
  )
}

export default ListaTransaccionesPage
